<template>
<div class="container">
  <h6 class="s-title s-title__small" v-if="!token">请填写你账号信息</h6>
  <div class="s-card" v-if="!token">
    <div class="s-form-group">
      <label for="" class="s-form-label s-form-label_100"><em class="s-form-need">*</em>手机号码</label>
      <div class="s-form-controller">
        <input type="text" placeholder="请填写你的手机号码" class="s-input" v-model="info.name">
      </div>
    </div>
    <div class="s-form-group">
      <label for="" class="s-form-label s-form-label_100"><em class="s-form-need">*</em>密码</label>
      <div class="s-form-controller">
        <input type="password" placeholder="请填写你的密码" class="s-input" v-model="info.password">
      </div>
    </div>
    <div class="s-form-group">
      <label for="" class="s-form-label s-form-label_100"><em class="s-form-need">*</em>确认密码</label>
      <div class="s-form-controller">
        <input type="password" placeholder="请填写你的确认密码" class="s-input" v-model="info.confirmPwd">
      </div>
    </div>
  </div>
  <h6 class="s-title s-title__small">请完善你信息</h6>
  <div class="s-card">
    <div class="s-form-group">
      <label for="" class="s-form-label s-form-label_100"><em class="s-form-need">*</em>抖音ID</label>
      <div class="s-form-controller">
        <input type="text" placeholder="请填写你的ID" class="s-input" v-model="info.douyinId">
      </div>
    </div>
    <div class="s-form-group">
      <label for="" class="s-form-label s-form-label_100"><em class="s-form-need">*</em>抖音昵称</label>
      <div class="s-form-controller">
        <input type="text" placeholder="请填写抖音昵称" class="s-input" v-model="info.douyinName">
      </div>
    </div>
    <div class="s-form-group">
      <label for="" class="s-form-label s-form-label_100"><em class="s-form-need">*</em>微信号</label>
      <div class="s-form-controller">
        <input type="text" placeholder="请填写你的微信号" class="s-input" v-model="info.weixinId" maxlength="20">
      </div>
    </div>
    <div class="s-form-group">
      <label for="" class="s-form-label s-form-label_100"><em class="s-form-need">*</em>抖音粉丝数</label>
      <div class="s-form-controller">
        <input type="number" placeholder="请填写你的抖音粉丝数" class="s-input" v-model="info.douyinFansCount">
      </div>
    </div>
    <div class="s-form-group">
      <label for="" class="s-form-label s-form-label_100"><em class="s-form-need">*</em>活动报价</label>
      <div class="s-form-controller">
        <input type="number" placeholder="请填写你的活动报价" class="s-input" v-model="info.campaignPrice">
        元
      </div>
    </div>
  </div>
  <div class="s-card">
    <div class="s-form-group">
      <label for="" class="s-form-label"><em class="s-form-need">*</em>达人自拍 <small>最多可上传3张</small></label>
    </div>
    <div class="s-form-group">
      <s-uploader @change="onUpload(0,$event)"
        :upload-url="uploadUrl"
        :initSrc="info.selfy[0]"
      >
        <div slot="preview"
          slot-scope="props"
          class="preview-wrap">
          <img class="preview"
            :src="props.src"
            v-preview="1">
          <button class="set-index" @click="info.selfyIndex=0" v-if="info.selfyIndex != 0">设为封面</button>
        </div>
      </s-uploader>
      <s-uploader @change="onUpload(1,$event)" 
        @error="onUploadError"
        :upload-url="uploadUrl">
        <div slot="preview" slot-scope="props">
          <img class="preview"
                :src="props.src"
                v-preview="1">
          <button class="set-index" @click="info.selfyIndex=1" v-if="info.selfyIndex != 1">设为封面</button>
        </div>
      </s-uploader>
      <s-uploader @change="onUpload(2,$event)"
        @error="onUploadError"
        :upload-url="uploadUrl">
        <div slot="preview" slot-scope="props">
          <img class="preview"
                :src="props.src"
                v-preview="1">
          <button class="set-index" @click="info.selfyIndex=2" v-if="info.selfyIndex != 2">设为封面</button>
        </div>
      </s-uploader>
    </div>
  </div>
  <div class="s-card">
    <div class="s-form-group">
      <label for="" class="s-form-label"><em class="s-form-need">*</em>达人分类 <small>最多可选3个类别</small></label>
    </div>
    <div>
      <ul class="info-classify-list">
        <li class="info-classify-item"
          :class="{'info-classify-item__selected':selectClass.indexOf(item.key) > -1}"
          v-for="(item, index) in classifyList"
          :key="index"
          @click="onSelectClass(item.key)">
          <div :class="'bg bg__'+ item.cls" >
            {{ item.key }}
          </div>
        </li>
      </ul>
    </div>
     <div class="s-form-group">
      <label for="" class="s-form-label">自定义</label>
      <div class="s-form-controller">
        <input type="text" placeholder="本宝宝有自己的想法哟" class="s-input" v-model="classify">
      </div>
    </div>
  </div>
  <div class="s-card">
    <div class="s-form-group">
      <label for="" class="s-form-label"><em class="s-form-need">*</em>商务作品展示 <small>请选择点赞最多或个人最满意的视频上传</small></label>
    </div>
    <div>
      <s-uploader @change="onUploadVideo(0,$event)" accept="video/*" :upload-url="uploadUrl" :initSrc="info.works[0]">
         <div slot="preview" slot-scope="props">
          <video class="preview" :src="props.src"></video>
        </div>
      </s-uploader>
    </div>
  </div>
  <div class="button-box">
    <button class="s-button s-button-primary s-button-block" @click="submit" :class="{'s-button__disabled':isSubmit}">提交</button>
  </div>
  <div class="s-dialog" v-if="dialogVisible">
    <div class="s-dialog-content">
      <div class="s-dialog-hd">
        <img src="../../assets/images/dialog_hd.png" alt="" class="dialog-hd-img">
      </div>
      <div class="s-dialog-bd">
        <p><strong>信息保存成功！</strong></p>
      </div>
      <div class="s-dialog-ft">
          <button class="s-button s-button-primary s-button-block"
            @click="handlerCloseDialog">关闭</button>
      </div>
    </div>
  </div>
</div>
</template>
<script>
import sUploader from '@/components/uploader'
import config from '@/utils/config'
import auth from '@/utils/auth'

export default {
  name: 'infoAdd',
  data() {
    return {
      info: {
        works: [],
        selfy: [],
        selfyIndex: 0
      },
      token:auth.getToken(),
      id: '',
      classify: '',
      selectClass: [],
      isSubmit: false,
      dialogVisible: false,
      showPreview: false,
      previewIndex: 0,
      uploadUrl: `${config.HOST}douyin/v1/upload`,
      code: '',
      classifyList: [
        {
          key: '游戏类',
          cls: 'youxi'
        },
        {
          key: '美妆类',
          cls: 'meizhuang'
        },
        {
          key: '运动类',
          cls: 'yundong'
        },
        {
          key: '潮人类',
          cls: 'chaoren'
        },
        {
          key: '音乐类',
          cls: 'yinyue'
        },
        {
          key: '跳舞类',
          cls: 'tiaowu'
        },
        {
          key: '演绎类',
          cls: 'yanyi'
        },
        {
          key: '段子类',
          cls: 'duanzi'
        },
        {
          key: '萌宠类',
          cls: 'mengchong'
        },
        {
          key: '美食类',
          cls: 'meishi'
        },
        {
          key: '生活类',
          cls: 'shenghuo'
        },
        {
          key: '技术类',
          cls: 'jishu'
        }
      ]
    }
  },
  methods: {
    onPreviewHide() {
      this.showPreview = false
    },
    onPreview(index) {
      this.previewIndex = index
      this.showPreview = true
    },
    submit() {
      if (this.isSubmit) {
        return
      }

      let info = Object.assign({}, this.info)
      if(!this.token){
        if (!info.name) {
          return this.$toast.show('手机号码不能为空')
        }
        if (!info.password) {
          return this.$toast.show('密码不能为空')
        }
        if (!info.confirmPwd) {
          return this.$toast.show('确认密码不能为空')
        }
        if(info.password !== info.confirmPwd ){
          return this.$toast.show('两次密码不一致')
        }
      }
      

      if (!info.douyinId) {
        return this.$toast.show('抖音ID不能为空')
      }

      if (!info.douyinName) {
        return this.$toast.show('抖音名称不能为空')
      }

      if (!info.douyinFansCount) {
        return this.$toast.show('抖音粉丝数不能为空或为0')
      }
      if (!/^\d+$/.test(info.douyinFansCount)) {
        return this.$toast.show('抖音粉丝数必须是正整数')
      }
      if (!info.weixinId) {
        return this.$toast.show('微信号不能为空')
      }
      if (info.weixinId.length > 20) {
        return this.$toast.show('微信号不能超过20个字符')
      }

      if (!info.campaignPrice) {
        return this.$toast.show('活动报价不能为空或为0')
      }
      if (info.campaignPrice < 0) {
        return this.$toast.show('活动报价不能为负')
      }

      if (info.selfy.length === 0) {
        return this.$toast.show('自拍至少一张')
      }

      let selectClass = this.selectClass.map(i => i)
      if (this.classify && selectClass.length < 3) {
        selectClass.push(this.classify)
      }

      if (selectClass.length === 0) {
        return this.$toast.show('分类不能为空')
      }

      if (info.works.length === 0) {
        return this.$toast.show('商品作品不能为空')
      }

      info.category = selectClass
      info.campaignPrice = +info.campaignPrice
      info.douyinFansCount = +info.douyinFansCount

      this.$http.post(`${config.HOST}douyin/v1/${this.token?'kol/editKol':'user/register'}`, info, {
        params:{
          token: this.token
        }
      }).then(
        response => {
          let data = response.body
          if (data.code === 0) {
            this.dialogVisible = true
            // this.isSubmit = true
            // this.id = data.data.id
          } else {
            this.$toast.show(data.errorMessage || '保存失败')
          }
        },
        response => {
          // error callback
        }
      )
    },
    getInfo () {
      this.$http.get(`${config.HOST}douyin/v1/kol/myKol`)
        .then(response => {
          let data = response.body
          if (data.code === 0) {
            this.info = data.data
            this.selectClass = data.data.category
          } else {

          }
        }, response => {
        // error callback
        })
    },
    onSelectClass(cls) {
      let index = this.selectClass.indexOf(cls)

      if (index > -1) {
        this.selectClass.splice(index, 1)
      } else if (this.selectClass.length < 3) {
        this.selectClass.push(cls)
      }
    },
    onUpload(key, file) {
      if (file) {
        this.info.selfy[key] = file.url
      } else {
        this.info.selfy.splice(key, 1)
      }
    },
    onUploadVideo(key, file) {
      if (file) {
        this.info.works[key] = file.url
      } else {
        this.info.works.splice(key, 1)
      }
    },
    onUploadError(error) {
      console.log(error)
      this.$toast.show('上传失败')
    },
    handlerCloseDialog() {
      this.dialogVisible = false
      this.$router.push({
        name: 'my'
      })    
    }
  },
  mounted() {
    if (this.token) {
      this.getInfo()
    }
  },
  components: {
    's-uploader': sUploader
  }
}
</script>

<style scoped lang="less">
@import './add.less';
.s-color-primary {
  color: #fe2b55;
}
.s-dialog {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  &-content {
    width: 250px;
    background-color: #fff;
    position: absolute;
    top: 30%;
    left: 50%;
    margin-left: -125px;
    border-radius: 15px;
    padding: 15px;
    text-align: center;
  }
  &-hd {
    .dialog-hd-img {
      width: 387/2px;
      height: 211/2px;
      margin-top: -80px;
    }
  }
  &-bd {
    margin: 30px 0;
    font-size: 18px;
    color: #5d5e66;
  }
}
.set-index {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  color: #5d5e66;
  font-size: 12px;
  background: #face12;
  border: none;
  outline: none;
  z-index: 3;
}
</style>



// WEBPACK FOOTER //
// src/containers/info/Add.vue